/* eslint-disable @next/next/no-page-custom-font */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { useEffect, useState } from 'react';
import '../styles/globals.css';
import '../styles/normalize.css';
import { ThemeProvider } from '@mui/system';
import customTheme from '@config/styles/customTheme';
import { ApolloProvider } from '@config/apollo';
import { ToastProvider } from '@hooks/toast.hook';

import CssBaseline from '@mui/material/CssBaseline';
import packageJson from '../../../package.json';
import { init } from '../src/utils/sentry';
import { useTrack } from '@hooks/useTrack';

import '../src/utils/wdyr';
import { useVhFix } from '@hooks/useVhFix';
import { useSessionId } from '@hooks/useSessionId';
import { AuthStateProvider } from '@hooks/useAuth';
import { MekiStateProvider } from '@hooks/useMekiState';
import { OrderStateProvider } from '@hooks/useOrderState';
import { CartMenuProvider } from '@hooks/useCartMenu';
import { ScrollProvider } from '@hooks/useScroll';
import { OpenModalProvider } from '@hooks/useModalOpenState';
import { FocusSearchBoxProvider } from '@hooks/useFocusSearchBox';
import { OrderInPaymentValidationProvider } from '@hooks/useOrderInPaymentValidation';
import { PillBoxProvider } from '@screens/home/components/virtualPillBox/hooks/usePillBoxState';
import {
  BASE_URL,
  GOOGLE_TAG_MANAGER,
  NEXT_PUBLIC_AMPLITUDE_API_KEY,
  NEXT_PUBLIC_PIXEL_ID,
} from '@config/environment';
import { useOpenReplay } from '@services/openreplay';
import Head from 'next/head';
import { useRefererParam } from '@hooks/useRefererParam';
import { AddressFormDataProvider } from '@screens/address/hooks/useAddressFormData';
import { Partytown } from '@builder.io/partytown/react';
import { useRouterHistory } from '@hooks/useRouterHistory';
import { ReferralsNoNewUserDialog } from '@components/ReferralsNoNewUserDialog';
import { ModalNavigation } from '@components/ModalNavigation';
import createEmotionCache from '../src/createEmotionCache';
import { CacheProvider } from '@emotion/react';

// eslint-disable-next-line no-console
const Track = () => {
  React.useEffect(() => {
    setTimeout(init);
  }, []);
  useTrack();
  return null;
};
const clientSideEmotionCache = createEmotionCache();
console.log(`Version ${packageJson.version}`);
function MyApp({
  Component,
  pageProps,
  emotionCache = clientSideEmotionCache,
  err,
}) {
  const [loaded, setLoaded] = useState(false);
  useVhFix();
  useSessionId();
  useOpenReplay();
  useRefererParam();
  useRouterHistory();
  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);

  useEffect(function handleLoaded() {
    setLoaded(true);
  }, []);
  return (
    <>
      <CacheProvider value={emotionCache}>
        <Head>
          <meta
            name="viewport"
            content="initial-scale=1, viewport-fit=cover maximum-scale=1.5"
          />
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin="anonymous"
          />
          <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
          <link rel="dns-prefetch" href="https://fonts.gstatic.com" />
          <Partytown
            resolveUrl={function (url) {
              if (
                ['connect.facebook.net', 'www.googletagmanager.com'].includes(
                  url.hostname,
                )
              ) {
                const proxyUrl = new URL(`${BASE_URL}/api/pixelProxy`);
                proxyUrl.searchParams.append('url', url.href);
                return proxyUrl;
              }
              return url;
            }}
            forward={[
              'fbq',
            ]}
          />
          {GOOGLE_TAG_MANAGER && (
            // eslint-disable-next-line @next/next/next-script-for-ga
            <script
              id="tag-manager"
              dangerouslySetInnerHTML={{
                __html: `window.dataLayer = [];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER}');`,
              }}
              async
            ></script>
          )}
          {NEXT_PUBLIC_AMPLITUDE_API_KEY && (
            <script
              dangerouslySetInnerHTML={{
                __html: `!function(){"use strict";!function(e,t){var r=e.amplitude||{_q:[],_iq:[]};if(r.invoked)e.console&&console.error&&console.error("Amplitude snippet has been loaded.");else{r.invoked=!0;var n=t.createElement("script");n.type="text/javascript",n.integrity="sha384-TOz7mAaluRbBsbarp1gIKuFu7gS1u3Gf6J0gfXXk7zIkQLPc/76FUk2Z/jpCQ67B",n.crossOrigin="anonymous",n.async=!0,n.src="https://cdn.amplitude.com/libs/analytics-browser-2.17.8-min.js.gz",n.onload=function(){e.amplitude.runQueuedFunctions||console.log("[Amplitude] Error: could not load SDK")};var s=t.getElementsByTagName("script")[0];function v(e,t){e.prototype[t]=function(){return this._q.push({name:t,args:Array.prototype.slice.call(arguments,0)}),this}}s.parentNode.insertBefore(n,s);for(var o=function(){return this._q=[],this},i=["add","append","clearAll","prepend","set","setOnce","unset","preInsert","postInsert","remove","getUserProperties"],a=0;a<i.length;a++)v(o,i[a]);r.Identify=o;for(var u=function(){return this._q=[],this},c=["getEventProperties","setProductId","setQuantity","setPrice","setRevenue","setRevenueType","setEventProperties"],l=0;l<c.length;l++)v(u,c[l]);r.Revenue=u;var p=["getDeviceId","setDeviceId","getSessionId","setSessionId","getUserId","setUserId","setOptOut","setTransport","reset"],d=["init","add","remove","track","logEvent","identify","groupIdentify","setGroup","revenue","flush"];function f(e){function t(t,r){e[t]=function(){if (!e._q){e._q=[]}var n={promise:new Promise((r=>{e._q.push({name:t,args:Array.prototype.slice.call(arguments,0),resolve:r})}))};if(r)return n}}for(var r=0;r<p.length;r++)t(p[r],!1);for(var n=0;n<d.length;n++)t(d[n],!0)}f(r),r.createInstance=function(){var e=r._iq.push({_q:[]})-1;return f(r._iq[e]),r._iq[e]},e.amplitude=r}}(window,document)}();const k = localStorage.getItem('akey');const u = localStorage.getItem('ukey');amplitude.init("${NEXT_PUBLIC_AMPLITUDE_API_KEY}",u ? JSON.parse(u) : undefined,{deviceId:k?JSON.parse(k):undefined}, {incluteUtm: true});`,
              }}
            ></script>
          )}
          {NEXT_PUBLIC_PIXEL_ID && (
            <>
              <script
                type="text/partytown"
                dangerouslySetInnerHTML={{
                  __html: `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${NEXT_PUBLIC_PIXEL_ID}');
fbq('track', 'PageView');`,
                }}
              ></script>
              <noscript>
                <img
                  alt="facebook"
                  height="1"
                  width="1"
                  style={{ display: 'none' }}
                  src={`https://www.facebook.com/tr?id=${NEXT_PUBLIC_PIXEL_ID}&ev=PageView&noscript=1`}
                />
              </noscript>
            </>
          )}

          {loaded && (
            <>
              <link
                href="https://fonts.googleapis.com/icon?family=Material+Icons&display=swap"
                rel="stylesheet"
              />
              <link
                href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
                rel="stylesheet"
              />
            </>
          )}
          <noscript>
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/icon?family=Material+Icons&display=swap"
            />
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
            />
          </noscript>
        </Head>
        <ToastProvider>
          <ApolloProvider>
            <AuthStateProvider>
              <Track />
              <MekiStateProvider>
                <OrderStateProvider>
                  <AddressFormDataProvider>
                    <CartMenuProvider>
                      <FocusSearchBoxProvider>
                        <ThemeProvider theme={customTheme}>
                          <CssBaseline />
                          <ScrollProvider>
                            <OpenModalProvider>
                              <PillBoxProvider>
                                <OrderInPaymentValidationProvider>
                                  <Component {...pageProps} err={err} />
                                  <ModalNavigation {...pageProps} />
                                </OrderInPaymentValidationProvider>
                              </PillBoxProvider>
                              <ReferralsNoNewUserDialog />
                            </OpenModalProvider>
                          </ScrollProvider>
                        </ThemeProvider>
                      </FocusSearchBoxProvider>
                    </CartMenuProvider>
                  </AddressFormDataProvider>
                </OrderStateProvider>
              </MekiStateProvider>
            </AuthStateProvider>
          </ApolloProvider>
        </ToastProvider>
      </CacheProvider>
    </>
  );
}

export default MyApp;
